var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { chunk } from 'lodash';
import { FULFILLED_STATUS } from 'constants/app.constant';
import { facadeApi, perFacadeApi } from 'helpers/api.helper';
var EAQ_TOPIC_MAPPED_HESI_EXAM_CHUNK_SIZE = 10;
var fetchEAQTopicMappedHesiExam = function (isbnList) { return __awaiter(void 0, void 0, Promise, function () {
    var result, promises, responses;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                result = [];
                promises = chunk(isbnList, EAQ_TOPIC_MAPPED_HESI_EXAM_CHUNK_SIZE).map(function (element) {
                    var url = "/performancereport/ehr/recommendation/learning/catalog?filter%5Bisbns%5D=".concat(element, "&filter%5BlearningType%5D=HESI_EXAM&included=TAXONOMY");
                    return facadeApi.get(url);
                });
                return [4 /*yield*/, Promise.allSettled(promises)];
            case 1:
                responses = _a.sent();
                responses.forEach(function (response) {
                    var _a, _b;
                    if (response.status === FULFILLED_STATUS && ((_b = (_a = response.value) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.included)) {
                        result.push.apply(result, response.value.data.included);
                    }
                });
                return [2 /*return*/, result];
        }
    });
}); };
var fetchEAQTopicMappedHesiExamByISBN = function (isbnList) { return __awaiter(void 0, void 0, Promise, function () {
    var chunks, chunkResults, eaqTopicMappedHesiExamByISBN;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                chunks = chunk(isbnList, EAQ_TOPIC_MAPPED_HESI_EXAM_CHUNK_SIZE);
                return [4 /*yield*/, Promise.allSettled(chunks.map(function (isbnChunk) { return fetchEAQTopicMappedHesiExam(isbnChunk); }))];
            case 1:
                chunkResults = _a.sent();
                eaqTopicMappedHesiExamByISBN = {};
                chunkResults.forEach(function (result, index) {
                    if (result.status === FULFILLED_STATUS && result.value.length > 0) {
                        chunks[index].forEach(function (isbn) {
                            eaqTopicMappedHesiExamByISBN[isbn] = result.value;
                        });
                    }
                });
                return [2 /*return*/, eaqTopicMappedHesiExamByISBN];
        }
    });
}); };
var collectFulfilledArrayData = function (promises) { return __awaiter(void 0, void 0, Promise, function () {
    var result, responses;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                result = [];
                return [4 /*yield*/, Promise.allSettled(promises)];
            case 1:
                responses = _a.sent();
                responses.forEach(function (response) {
                    var _a;
                    if (response.status === FULFILLED_STATUS && Array.isArray((_a = response.value) === null || _a === void 0 ? void 0 : _a.data)) {
                        result.push.apply(result, response.value.data);
                    }
                });
                return [2 /*return*/, result];
        }
    });
}); };
var fetchMasteryAssessment = function (isbnList, courseId) {
    return collectFulfilledArrayData(isbnList.map(function (isbn) { return perFacadeApi.get("/v2/assessment/mastery/".concat(isbn, "/").concat(courseId)); }));
};
var fetchEHRStudents = function (isbnList, courseId, studentId) { return __awaiter(void 0, void 0, Promise, function () {
    var result, promises, responses;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                result = [];
                promises = [];
                if (studentId) {
                    promises = isbnList.map(function (isbn) { return perFacadeApi.get("/ehr/assessment/mastery/".concat(isbn, "/").concat(courseId, "?userId=").concat(studentId)); });
                }
                else {
                    promises = isbnList.map(function (isbn) { return perFacadeApi.get("/ehr/assessment/mastery/".concat(isbn, "/").concat(courseId)); });
                }
                return [4 /*yield*/, Promise.allSettled(promises)];
            case 1:
                responses = _a.sent();
                responses.forEach(function (response) {
                    var _a;
                    if (response.status === FULFILLED_STATUS && ((_a = response.value) === null || _a === void 0 ? void 0 : _a.data) && Array.isArray(response.value.data)) {
                        result.push.apply(result, response.value.data);
                    }
                });
                return [2 /*return*/, result];
        }
    });
}); };
export { fetchEAQTopicMappedHesiExam, fetchEAQTopicMappedHesiExamByISBN, fetchEHRStudents, fetchMasteryAssessment };
